"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const dist_1 = require("../../../fs/dist");
exports.toolDef = {
    name: 'loom_find_doc',
    description: 'Resolve a document id to its absolute file path. Returns an error if the document is not found.',
    inputSchema: {
        type: 'object',
        properties: {
            id: { type: 'string', description: 'Document id to look up' },
        },
        required: ['id'],
    },
};
async function handle(root, args) {
    const id = args['id'];
    const resolved = await (0, dist_1.resolveDocIdOrThrow)(root, id);
    return { content: [{ type: 'text', text: JSON.stringify(resolved) }] };
}
